/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTrimesterObservations } from 'app/entities/trimester-observation/trimester-observation.reducer';
import { getEntities as getSpecialityVitals } from 'app/entities/speciality-vitals/speciality-vitals.reducer';
import { createEntity, getEntity, reset, updateEntity } from './trimester-observation-param.reducer';

export const TrimesterObservationParamUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const trimesterObservations = useAppSelector(state => state.trimesterObservation.entities);
  const specialityVitals = useAppSelector(state => state.specialityVitals.entities);
  const trimesterObservationParamEntity = useAppSelector(state => state.trimesterObservationParam.entity);
  const loading = useAppSelector(state => state.trimesterObservationParam.loading);
  const updating = useAppSelector(state => state.trimesterObservationParam.updating);
  const updateSuccess = useAppSelector(state => state.trimesterObservationParam.updateSuccess);

  const handleClose = () => {
    navigate(`/trimester-observation-param${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTrimesterObservations({}));
    dispatch(getSpecialityVitals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...trimesterObservationParamEntity,
      ...values,
      trimester: trimesterObservations.find(it => it.id.toString() === values.trimester?.toString()),
      vital: specialityVitals.find(it => it.id.toString() === values.vital?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...trimesterObservationParamEntity,
          trimester: trimesterObservationParamEntity?.trimester?.id,
          vital: trimesterObservationParamEntity?.vital?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.trimesterObservationParam.home.createOrEditLabel" data-cy="TrimesterObservationParamCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.trimesterObservationParam.home.createOrEditLabel">
              Create or edit a TrimesterObservationParam
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="trimester-observation-param-id"
                  label={translate('tinyMedicRestApp.trimesterObservationParam.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.trimesterObservationParam.observation')}
                id="trimester-observation-param-observation"
                name="observation"
                data-cy="observation"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.trimesterObservationParam.comments')}
                id="trimester-observation-param-comments"
                name="comments"
                data-cy="comments"
                type="text"
                validate={{
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.trimesterObservationParam.draft')}
                id="trimester-observation-param-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.trimesterObservationParam.active')}
                id="trimester-observation-param-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.trimesterObservationParam.cursor')}
                id="trimester-observation-param-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.trimesterObservationParam.lastUpdated')}
                id="trimester-observation-param-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.trimesterObservationParam.microSec')}
                id="trimester-observation-param-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.trimesterObservationParam.timestampEntry')}
                id="trimester-observation-param-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="trimester-observation-param-trimester"
                name="trimester"
                data-cy="trimester"
                label={translate('tinyMedicRestApp.trimesterObservationParam.trimester')}
                type="select"
              >
                <option value="" key="0" />
                {trimesterObservations
                  ? trimesterObservations.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="trimester-observation-param-vital"
                name="vital"
                data-cy="vital"
                label={translate('tinyMedicRestApp.trimesterObservationParam.vital')}
                type="select"
              >
                <option value="" key="0" />
                {specialityVitals
                  ? specialityVitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/trimester-observation-param" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TrimesterObservationParamUpdate;
